export default __webpack_public_path__ + "static/media/co2logic-logo.09bb7e3e.svg";